/**
 * Shared "not found or expired" page (spec.md § Routing & pages). The same page
 * is returned for both 404 (never existed) and 410 (expired) — the UI collapses
 * them. Single CTA: "Start a new pad", which navigates to `/` (mints a fresh
 * pad and redirects). Minimal, same design language as the rest of the app.
 */

import { useNavigate } from "react-router-dom";

export function NotFound(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <p className="mb-6 max-w-md font-sans text-[16.5px] leading-[1.72] text-text-2">
        This pad doesn&rsquo;t exist or has expired.
      </p>
      <button
        type="button"
        onClick={() => {
          void navigate("/");
        }}
        className="inline-flex items-center rounded-[9px] bg-primary px-4 py-2.5 font-mono text-[13px] font-medium text-primary-fg outline-none transition-opacity hover:opacity-90 focus-visible:ring-3 focus-visible:ring-accent/40 active:translate-y-px"
      >
        Start a new pad
      </button>
    </main>
  );
}
